import useIsNewTrainingUIEnabled from '@/hooks/useIsNewTrainingUIEnabled';

import Deployments from './Deployments';
import DeploymentsLegacy from './Deployments_Legacy';
import Settings from './Settings';
import { Container } from './styled';

function Details() {
  const isNewTrainingUIEnabled = useIsNewTrainingUIEnabled();

  return (
    <Container sx={{ display: { xs: 'none', lg: 'flex' } }}>
      <Settings />
      {isNewTrainingUIEnabled ? <Deployments /> : <DeploymentsLegacy />}
    </Container>
  );
}

export default Details;
